import { createContext, useContext, useEffect, useState } from 'react'

interface HeadManagerContextProps {
  setTitle: (title: string) => void
  setDescription: (description: string) => void
}

const HeadManagerContext = createContext<HeadManagerContextProps | undefined>(
  undefined,
)

export const HeadManagerProvider: React.FC<{
  children: React.ReactNode
  baseTitle?: string
}> = ({ children, baseTitle = '%s | Rifa-Aqui' }) => {
  const [title, setTitle] = useState<string>('')
  const [description, setDescription] = useState<string>('')

  useEffect(() => {
    document.title = baseTitle.replace('%s', title)
  }, [title, baseTitle])

  useEffect(() => {
    if (description) {
      let metaTag = document.querySelector(
        "meta[name='description']",
      ) as HTMLMetaElement
      if (!metaTag) {
        metaTag = document.createElement('meta')
        metaTag.name = 'description'
        document.head.appendChild(metaTag)
      }
      metaTag.content = description
    }
  }, [description])

  return (
    <HeadManagerContext.Provider value={{ setTitle, setDescription }}>
      {children}
    </HeadManagerContext.Provider>
  )
}

export const useHeadManager = () => {
  const context = useContext(HeadManagerContext)
  if (!context) {
    throw new Error(
      'useHeadManager deve ser usado dentro de um HeadManagerProvider',
    )
  }
  return context
}
